import { showErrorAction, clearErrorAction } from "../error/errorActionCreator";
import { hideLoaderAction, showLoaderAction } from "../loader/loaderActionCreator";
import { getValidationErrorMessages } from '../../utility/commonUtility';
import { getResourcePermissions } from '../../services/auth';
import { SNACKBAR_ALERT_DEFAULT_PROPS } from '../../shared/constants';
import { setSnackBarDisplay } from '../snackBar/snackBarActionCreator';


export const getAuthPermissions = async (dispatch: Function, payload:any) => {
  let assignedPermissions: any = [];
  try {
    dispatch(showLoaderAction());
    dispatch(clearErrorAction());
    const permissionsData = await getResourcePermissions(payload);
    const resources = {};
    permissionsData[0]?.resources?.forEach((item: any) => item?.resource && (resources[item.resource] = item));
    assignedPermissions = {
      ...permissionsData[0],
      resources
    };
    dispatch(hideLoaderAction());
    return assignedPermissions;
  } catch (error: any) {
    const errorMessageDetail = getValidationErrorMessages(error);
    const errorMessage = {
      message: 'Error in fetching Resource Permissions: ' + errorMessageDetail
    };
    dispatch(showErrorAction(errorMessage));
    dispatch(hideLoaderAction());
    dispatch(
      setSnackBarDisplay({
        ...SNACKBAR_ALERT_DEFAULT_PROPS,
        show: true,
        message: 'Error in Get Customer data: ' + errorMessageDetail,
        severity: 'error',
      })
    );
  }
};